// JS
// header navigation

import { who_is_navigation_mobile } from "./helpers.js" ;


export default class HeaderNavigation {

    constructor() {

        // Toggle mobile
        const navigation_toggle = document.querySelector( '.site-header-navigation__navigation-toggle' ) ;
        navigation_toggle.addEventListener( 'click', (e ) => { this.header_navigation__toggle( e ); } );


        // Accordeons mobile
        const nav_buttons = document.querySelectorAll( '.site-header .menu-item-element--button' ) ;
        this.nav_buttons = nav_buttons ;
        this.nav_buttons.forEach(function ( btn, index ){
            btn.addEventListener( 'click', (e ) => { e.stopPropagation(); e.preventDefault(); } );
        });

        const top_nav_buttons = document.querySelectorAll( '.site-header .menu-item--level-0 > .menu-item-element--button' ) ;
        this.top_nav_buttons = top_nav_buttons ;
        this.top_nav_buttons.forEach(function ( btn, index ){
            btn.addEventListener( 'click', (e ) => { this.header_navigation__toggle_submenu( e ); } );
        });


        // Focus Out

        const site_header_bottom_bar = document.querySelector( '.site-header__bottom-bar' ) ;
        site_header_bottom_bar.addEventListener( 'click', (e ) => { e.stopPropagation(); } );

        const html = document.querySelector( 'html' ) ;
        html.addEventListener( 'click', (e ) => { this.header_navigation__focusout( e ); } );

        // keyboard x focusout
        document.addEventListener('keyup', ( e )=>{ this.header_search__keyboard( e ); } );
    }

    header_navigation__toggle( e ){

        e.preventDefault();
        let elt = e.currentTarget ;

        const body = document.querySelector('body') ;
        body.classList.toggle("has--site-header-navigation--open");

        if( ! body.classList.contains('has--site-header-navigation--open') ){
            this.header_navigation__close();
        }

    }



    header_navigation__close(){

        const top_nav_buttons = document.querySelectorAll( '.site-header .menu-item--level-0 > .menu-item-element--button' ) ;
        top_nav_buttons.forEach(function ( btn, index ){
            btn.classList.remove( 'has--menu-open' );
        });

    }

    header_navigation__toggle_submenu(e){

        e.stopPropagation();
        e.preventDefault();
        let elt = e.currentTarget ;

        if( elt.classList.contains("has--menu-open") ){

            if( ! who_is_navigation_mobile() ){
                this.top_nav_buttons.forEach(function ( btn, index ){
                    btn.classList.remove( 'has--menu-open' );
                });
            }

            elt.classList.remove( 'has--menu-open' );
            elt.blur();

        }else{

            if( ! who_is_navigation_mobile() ){
                this.top_nav_buttons.forEach(function ( btn, index ){
                    btn.classList.remove( 'has--menu-open' );
                });
            }

            elt.classList.add( 'has--menu-open' );
            elt.blur();
        }

    }

    header_navigation__focusout( e ){

        // const nav_buttons = document.querySelectorAll( '.menu-item-element--button' ) ;
        this.nav_buttons.forEach(function ( btn, index ){
            btn.classList.remove( 'has--menu-open' );
        });
    }

    header_search__keyboard( e ){

        if( 'Escape' === String( e.key ) ){
            this.header_navigation__close();
        }
    }


}

